<template>
  <div class="vx-row pt-5 px-5">
    <div class="vx-col w-full px-8">
      <form method="POST" @submit.prevent="save_changes">
        <div class="vx-row">
          <!-- Vertical Thumbnail Image -->
          <div class="vx-col w-1/2 cursor-pointer">
            <label class="vs-input--label block">Vertical Thumbnail Image (600px * 728px)</label>
            <input
              type="file"
              class="border p-2 rounded w-full"
              name="image"
              ref="files"
              accept=".jpg, .png , .jpeg"
              @change="handleFileUpload($event, 75 / 91, 'vertical_thumbnail')"
              style="border: 1px solid rgba(0, 0, 0, 0.2)"
              v-validate="imagevalidationRule"
              data-vv-as="Image"
            />
            <span class="text-danger text-sm" v-show="errors.has('image')">{{ errors.first('image') }}</span>
            <div class="mt-5">
              <div class="relative" v-if="vertical_thumbnail.preview_image">
                <div class="mt-5 overflow-hidden">
                  <img height="364px" width="300px" :src="vertical_thumbnail.preview_image" alt="Image Preview" class="object-fit" />
                </div>
              </div>
            </div>
          </div>
          <!-- Square Thumbnail Image -->
          <div class="vx-col w-1/2 cursor-pointer">
            <label class="vs-input--label block">Square Thumbnail Image (512px * 512px)</label>
            <input
              type="file"
              class="border p-2 rounded w-full"
              name="image"
              ref="files"
              accept=".jpg, .png , .jpeg"
              @change="handleFileUpload($event, 1 / 1, 'square_thumbnail')"
              style="border: 1px solid rgba(0, 0, 0, 0.2)"
              v-validate="imagevalidationRule"
              data-vv-as="Image"
            />
            <span class="text-danger text-sm" v-show="errors.has('image')">{{ errors.first('image') }}</span>
            <div class="mt-5">
              <div class="relative" v-if="square_thumbnail.preview_image">
                <div class="mt-5 overflow-hidden">
                  <img height="185px" width="185px" :src="square_thumbnail.preview_image" alt="Image Preview" class="object-fit" />
                </div>
              </div>
            </div>
          </div>
          <!-- Live Thumbnail Image -->
          <div class="vx-col w-1/2 cursor-pointer">
            <label class="vs-input--label block">Live Thumbnail Image (512px * 512px)</label>
            <input
              type="file"
              class="border p-2 rounded w-full"
              name="image"
              ref="files"
              accept=".jpg, .png , .jpeg"
              @change="handleFileUpload($event, 1 / 1, 'live_thumbnail')"
              style="border: 1px solid rgba(0, 0, 0, 0.2)"
              v-validate="imagevalidationRule"
              data-vv-as="Image"
            />
            <span class="text-danger text-sm" v-show="errors.has('image')">{{ errors.first('image') }}</span>
            <div class="mt-5">
              <div class="relative" v-if="live_thumbnail.preview_image">
                <div class="mt-5 overflow-hidden">
                  <img height="185px" width="185px" :src="live_thumbnail.preview_image" alt="Image Preview" class="object-fit" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row pt-5 px-5 text-center">
          <div class="vx-col w-full">
            <div class="items-center">
              <vs-button class="mr-2 vs-con-loading__container" id="create-creator" @click="save_changes"> {{ $route.params.id ? 'Update' : 'Add' }}</vs-button>
              <!-- <vs-button color="danger" class="text-left" @click="navigateList">Cancel</vs-button> -->
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- <vs-popup title="Image Cropper" name="Image" :active.sync="IsOpenImageCrop" class="image-cropper" style="z-index: 55000">
      <div class="text-center flex justify-center w-full h-full">
        <div class="modal__content w-full h-full">
          <div class="modal-body w-full h-full">
            <div class="modal-form w-full h-full">
              <div class="w-full h-full max-h-450">
                <cropper
                  ref="cropper"
                  name="Image"
                  class="cropper-image"
                  :src="this.crop_image.src"
                  :stencil-props="{
                    aspectRatio: this.cropperRatio
                  }"
                />
              </div>
              <div class="button-wrapper mt-3">
                <vs-button type="" @click="cropImage()" class="text-primary border border-solid border-primary">Crop Image</vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vs-popup> -->
</template>
<script>
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import { mapActions, mapState } from 'vuex'
export default {
  /** Page Name */
  name: 'Graphics-Management',

  /** components */
  components: {
    Cropper
  },

  /** data */
  data() {
    return {
      contentType: null,
      cropperRatio: null,
      form: {
        vertical_thumbnail: null,
        square_thumbnail: null,
        live_thumbnail: null
      },
      vertical_thumbnail: {
        preview_image: ''
      },
      square_thumbnail: {
        preview_image: ''
      },
      live_thumbnail: {
        preview_image: ''
      },
      crop_image: {
        src: '',
        type: '',
        isRound: true
      },
      IsOpenImageCrop: false
    }
  },

  /** computed */
  computed: {
    ...mapState('gurudwara', ['createLoading']),
    validateForm() {
      return !this.errors.any()
    },
    imagevalidationRule() {
      // return !this.$route.params.id ? 'required' : ''
    }
  },

  /** created */
  async created() {
    if (this.$route.params.id) {
      await this.$store.dispatch('gurudwara/show', this.$route.params.id).then(async (res) => {
        const data = res.data.data

        /* form variable */
        this.vertical_thumbnail.preview_image = data.vertical_thumbnail
        this.square_thumbnail.preview_image = data.square_thumbnail
        this.live_thumbnail.preview_image = data.live_thumbnail
      })
    }
  },

  /** methods */
  methods: {
    ...mapActions('gurudwara', {
      update: 'graphicsUpdate'
    }),
    ...mapActions('common', {
      getAdminPreDefinedValues: 'getAdminPreDefinedValues'
    }),
    async save_changes() {
      if (!(await this.$validator.validate())) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please fix the error first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      if (!this.$route.params.id && !this.form.image) {
        this.$vs.notify({
          title: 'Error',
          text: 'Image Is Required!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return false
      }
      try {
        let response
        const data = new FormData()
        data.append('vertical_thumbnail', this.form.vertical_thumbnail)
        data.append('square_thumbnail', this.form.square_thumbnail)
        data.append('live_thumbnail', this.form.live_thumbnail)
        if (this.$route.params.id) {
          response = await this.update({
            id: this.$route.params.id,
            data
          })
        }
        // this.$router.push({
        //   name: 'gurudwara-list'
        // })
        this.$vs.notify({
          title: 'Success',
          text: response.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
      }
    },

    /** navigate to list */
    navigateList() {
      this.$router.push({ name: 'mantra-list' })
    },

    /** file upload  */
    handleFileUpload(e, ratio, fileType) {
      this.cropperRatio = ratio
      this.contentType = fileType
      const file = e.target.files[0]

      // Check if a file is selected
      if (!file) {
        this.$vs.notify({
          title: 'Error',
          text: 'No file selected',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'primary'
        })
        return
      }

      const blob = URL.createObjectURL(file)

      switch (fileType) {
      case 'vertical_thumbnail':
        this.form.vertical_thumbnail = file
        this.vertical_thumbnail.preview_image = blob
        break
      case 'square_thumbnail':
        this.form.square_thumbnail = file
        this.square_thumbnail.preview_image = blob
        break
      case 'live_thumbnail':
        this.form.live_thumbnail = file
        this.live_thumbnail.preview_image = blob
        break
      default:
        console.warn('Unknown thumbnail type:', fileType)
      }

      // this.crop_image = {
      //   src: blob,
      //   type: file.type
      // }
      // this.IsOpenImageCrop = true
    }
    // cropImage() {
    //   const result = this.$refs.cropper.getResult()
    //   if (result.canvas == undefined) {
    //     this.$vs.notify({
    //       title: 'Error',
    //       text: 'Please Select Image',
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       position: 'top-center',
    //       time: 5000,
    //       color: 'primary'
    //     })
    //     return
    //   }
    //   const resultTest = result.canvas.toDataURL(this.crop_image.type)
    //   const base64Image = resultTest.replace(`data:${this.crop_image.type};base64,`, '')
    //   this.b64toBlob(base64Image, this.crop_image.type)

    //   this.IsOpenImageCrop = false
    // },
    // b64toBlob(b64Data, contentType = '', sliceSize = 512) {
    //   const byteCharacters = window.atob(b64Data)
    //   const byteArrays = []

    //   for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    //     const slice = byteCharacters.slice(offset, offset + sliceSize)

    //     const byteNumbers = new Array(slice.length)
    //     for (let i = 0; i < slice.length; i++) {
    //       byteNumbers[i] = slice.charCodeAt(i)
    //     }

    //     const byteArray = new Uint8Array(byteNumbers)
    //     byteArrays.push(byteArray)
    //   }

    //   const blob = new File(byteArrays, 'image.jpg', {
    //     type: contentType
    //   })
    //   switch (this.contentType) {
    //     case 'vertical_thumbnail':
    //       this.form.vertical_thumbnail = blob
    //       this.vertical_thumbnail.preview_image = URL.createObjectURL(blob)
    //       break
    //     case 'square_thumbnail':
    //       this.form.square_thumbnail = blob
    //       this.square_thumbnail.preview_image = URL.createObjectURL(blob)
    //       break
    //      case 'live_thumbnail':
    //       this.form.live_thumbnail = blob
    //       this.live_thumbnail.preview_image = URL.createObjectURL(blob)
    //       break
    //     default:
    //       console.warn('Unknown thumbnail type:', type)
    //   }
    //   // this.form.image = blob
    //   // this.preview_image = URL.createObjectURL(blob)
    //   return blob
    // }
  },

  /** watch */
  watch: {
    createLoading() {
      if (this.createLoading) {
        this.$vs.loading({
          container: '#create-creator',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#create-creator > .con-vs-loading')
      }
    }
  }
}
</script>
<style>
.cropper-image {
  height: 400px;
  background: #ddd;
}
</style>
